module.exports = __webpack_public_path__ + "media/images/icons/flags/RO-98add51e0da797ef619d6b62b1fd2efc.svg";